// @flow

import { type IncomingPayment } from './types';
import type { Merchant } from '@tectonics/prs/merchant';

export function getMerchant(incomingPayment: IncomingPayment): Merchant {
  return incomingPayment['merchant'];
}
